export default __webpack_public_path__ + "assets/img/input-file.svg";